<div id="spirit-detail">
    <header>
        <div class="back">
            <button mat-icon-button (click)="goBack()"><mat-icon>keyboard_arrow_left</mat-icon></button>
            @if(spirit()) {
                <span>{{ 'detail.back_button' | translate }} {{ spirit()?.catalogSpirit?.category | catalogTranslation }}</span>
            }
        </div>
        <p>{{ 'detail.title' | translate }}</p>
        @if (lockerUser && lockerCart.length > 0) {
            <button mat-icon-button class="go-to-locker-cart text-white" [matBadge]="lockerCart.length" [matBadgeHidden]="lockerCart.length < 1" matBadgeColor="primary" matBadgeSize="small" matBadgeOverlap="true"  (click)="goToLockerCart()">
                <locker-cart-add-icon></locker-cart-add-icon>
            </button>
        }
    </header>
    <main>
        @if(spirit()) {
            <!--
              Hero: the bottle and everything that identifies it — image, name, origin, price and
              locker. On a desktop it is the left column and stays put while the editorial body
              scrolls beside it, so the guest never loses sight of what they are reading about.
              On a phone the two stack into one column in the same reading order.
            -->
            <section class="hero">
                <div class="img">
                    <img [src]="spirit()?.catalogSpirit!.image | spiritImage" alt="">
                </div>

                <div class="identity">
                    <div class="row">
                        <h1>{{ spirit() | spiritTranslation:'name' }}</h1>
                        @if (!lockerUser) {
                            <div class="fav" [class.fav-active]="spirit()?.fav" (click)="favorite(spirit()!); $event.stopPropagation();">
                                <img src="assets/images/{{spirit()?.fav ? 'fav' : 'no-fav'}}.png"/>
                            </div>
                        }
                    </div>

                    <h4>{{ spirit() | spiritTranslation:'subname' }}</h4>

                    <h6 class="text-light">
                        {{ spirit()?.catalogSpirit!.type | catalogTranslation }}@if ( spirit()?.catalogSpirit!.type && spirit()?.catalogSpirit!.category ) {,}
                        {{ spirit()?.catalogSpirit!.category | catalogTranslation}}</h6>
                    <h6 class="text-light">
                        {{ spirit()?.catalogSpirit!.region | catalogTranslation }} @if ( spirit()?.catalogSpirit!.region && spirit()?.catalogSpirit!.country ) {/}
                        {{ spirit()?.catalogSpirit!.country | catalogTranslation }}
                    </h6>
                    <div class="prices text-light">
                        @defer (when menu()) {
                            @for (price of spirit()?.priceVariants; track price.uuid) {
                                <app-price [price]="price" [menu]="menu()" [showName]=true></app-price>
                            }
                        }
                    </div>

                    @if (lockerUser && spirit()?.priceVariants && spirit()?.priceVariants!.length > 0) {
                        <app-spirit-detail-locker [spirit]="spirit()" [lockerUser]="lockerUser" [menu]="menu()" (spiritAdded)="getLockerCart()"></app-spirit-detail-locker>
                    }
                </div>
            </section>

            <section class="info">
                <!--
                  The catalogue is handed to the editorial block so "Información del producto"
                  can state the bottle's identity beside the facts it verified, instead of
                  leaving the guest to find it at the bottom of the general list.
                -->
                @if (editorialContent(); as editorial) {
                    <app-spirit-editorial [data]="editorial" [catalogSpirit]="catalogSpirit()"></app-spirit-editorial>
                }

                <div class="section-title">
                    {{ 'detail.characteristics' | translate }}
                </div>

                @defer(when catalogSpirit()) {
                    <div class="characteristics">    
                             
                        <!--
                          Identity rows the editorial "product information" block already states.
                          Repeated here only when that block is not on screen at all.
                        -->
                        @if (showLegacyIdentity()) {
                            <app-spirit-detail-characteristic
                                name="brand"
                                [data]="catalogSpirit()?.brand"
                            ></app-spirit-detail-characteristic>
                        }

                        <!-- Legacy fallback, per block: only when no AI narrative arrived. -->
                        @if (showLegacyDescription()) {
                            <app-spirit-detail-characteristic
                                name="description"
                                [data]="spirit()"
                            ></app-spirit-detail-characteristic>
                        }

                        @if (showLegacyIdentity()) {
                            <app-spirit-detail-characteristic
                                name="age"
                                [data]="catalogSpirit()?.age"
                            ></app-spirit-detail-characteristic>
                        }

                        <app-spirit-detail-characteristic
                            name="vintage"
                            [data]="catalogSpirit()?.vintage"
                        ></app-spirit-detail-characteristic>

                        @if (showLegacyIdentity()) {
                            <app-spirit-detail-characteristic
                                name="volume"
                                [data]="catalogSpirit()?.volume"
                            ></app-spirit-detail-characteristic>

                            <app-spirit-detail-characteristic
                                name="capacity"
                                [data]="catalogSpirit()?.capacity"
                            ></app-spirit-detail-characteristic>
                        }

                        <!--
                          Legacy fallbacks, each gated on ITS OWN block. A spirit with published
                          axes but no editorial prose keeps its legacy tasting notes, and one
                          with prose but no assessment keeps its legacy scales.
                        -->
                        @if (showLegacyTastingNotes()) {
                            <app-spirit-detail-characteristic
                                name="tastingNotes"
                                [data]="spirit()"
                            ></app-spirit-detail-characteristic>
                        }

                        @if (showLegacyIngredients()) {
                            <app-spirit-detail-characteristic
                                name="ingredients"
                                [data]="spirit()"
                            ></app-spirit-detail-characteristic>
                        }

                        @if (showLegacyElaboration()) {
                            <app-spirit-detail-characteristic
                                name="elaboration"
                                [data]="spirit()"
                            ></app-spirit-detail-characteristic>
                        }

                        @if (showLegacyScales()) {
                            <app-spirit-detail-characteristic
                                name="body"
                                [data]="catalogSpirit()?.body"
                                class="w-auto"
                            ></app-spirit-detail-characteristic>

                            <app-spirit-detail-characteristic
                                name="richness"
                                [data]="catalogSpirit()?.richness"
                                class="w-auto"
                            ></app-spirit-detail-characteristic>

                            <app-spirit-detail-characteristic
                                name="smoke"
                                [data]="catalogSpirit()?.smoke"
                                class="w-auto"
                            ></app-spirit-detail-characteristic>

                            <app-spirit-detail-characteristic
                                name="sweetness"
                                [data]="catalogSpirit()?.sweetness"
                                class="w-auto"
                            ></app-spirit-detail-characteristic>
                        }

                        @if (showLegacyCharacters()) {
                            <app-spirit-detail-characteristic
                                name="characters"
                                [data]="catalogSpirit()?.characters"
                            ></app-spirit-detail-characteristic>
                        }

                        @if (showLegacyFoodPairings()) {
                            <app-spirit-detail-characteristic
                                name="foodPairings"
                                [data]="catalogSpirit()?.foodPairings"
                            ></app-spirit-detail-characteristic>
                        }

                        <app-spirit-detail-characteristic
                            name="caskNumber"
                            [data]="catalogSpirit()?.caskNumber"
                        ></app-spirit-detail-characteristic>

                        <app-spirit-detail-characteristic
                            name="caskType"
                            [data]="catalogSpirit()?.caskType"
                        ></app-spirit-detail-characteristic>

                        <app-spirit-detail-characteristic
                            name="style"
                            [data]="catalogSpirit()?.style"
                        ></app-spirit-detail-characteristic>

                        <app-spirit-detail-characteristic
                            name="flavour"
                            [data]="catalogSpirit()?.flavour"
                        ></app-spirit-detail-characteristic>

                        <app-spirit-detail-characteristic
                            name="ingType"
                            [data]="catalogSpirit()?.ingType"
                        ></app-spirit-detail-characteristic>

                        <app-spirit-detail-characteristic
                            name="grapes"
                            [data]="catalogSpirit()?.grapes"
                        ></app-spirit-detail-characteristic>

                        <app-spirit-detail-characteristic
                            name="bottler"
                            [data]="catalogSpirit()?.bottler"
                        ></app-spirit-detail-characteristic>

                        <app-spirit-detail-characteristic
                            name="bottlingStatus"
                            [data]="catalogSpirit()?.bottlingStatus"
                        ></app-spirit-detail-characteristic>

                        <app-spirit-detail-characteristic
                            name="numberOfBottles"
                            [data]="catalogSpirit()?.numberOfBottles"
                        ></app-spirit-detail-characteristic>

                        <app-spirit-detail-characteristic
                            name="limitedEdition"
                            [data]="catalogSpirit()?.limitedEdition"
                        ></app-spirit-detail-characteristic>

                        <app-spirit-detail-characteristic
                            name="series"
                            [data]="catalogSpirit()?.series"
                        ></app-spirit-detail-characteristic>

                        <app-spirit-detail-characteristic
                            name="bottlingDate"
                            [data]="catalogSpirit()?.bottlingDate"
                        ></app-spirit-detail-characteristic>

                        <app-spirit-detail-characteristic
                            name="certification"
                            [data]="catalogSpirit()?.certification"
                        ></app-spirit-detail-characteristic>

                        <app-spirit-detail-characteristic
                            name="sustainability"
                            [data]="catalogSpirit()?.sustainability"
                        ></app-spirit-detail-characteristic>

                        <app-spirit-detail-characteristic
                            name="colouring"
                            [data]="catalogSpirit()?.colouring"
                        ></app-spirit-detail-characteristic>

                        <app-spirit-detail-characteristic
                            name="chillFilter"
                            [data]="catalogSpirit()?.chillFilter"
                        ></app-spirit-detail-characteristic>

                        <app-spirit-detail-characteristic
                            name="noAdds"
                            [data]="catalogSpirit()?.noAdds"
                        ></app-spirit-detail-characteristic>

                    </div>
                }

            </section>
        }
    </main>
</div>
